// useAgentDashboardMetrics.js
import { useState, useEffect, useCallback } from "react";
import _ from "lodash";
import { getAgentDashboardMetrics } from "@/services";
import { getUserId } from "@/helpers";

const useAgentDashboardMetrics = (scope = "all") => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const userId = getUserId();

  const fetchMetrics = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    try {
      const response = await getAgentDashboardMetrics({ userId, scope });
      const result = _.get(response, "result", null);
      if (response.errorCode === 0) {
        setData(result);
      } else {
        setError(response);
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [userId, scope]);

  useEffect(() => {
    fetchMetrics();
  }, [fetchMetrics]);

  return { data, loading, error, refetch: fetchMetrics };
};

export default useAgentDashboardMetrics;
